export default __webpack_public_path__ + "static/fallback-share-image-e604c8300f3541728068e0e590395c4a.png";